
import axios from 'axios';
window.axios = axios;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.baseURL = `${process.env.VUE_APP_API_HTTPS}/`;
axios.defaults.withCredentials = true;

export default axios;
